// extracted by mini-css-extract-plugin
export default {"navLink":"t3gjAk5lPOTqsCCfwRXC","link":"yoEu56LnHkpI1kyPucbG","text":"TpQeTB8dHSxCqyQSbBWT","arrow":"WjSuT6bRpvItoiSny8xg","ctaButton":"VeTSB1kehiNFG8mhQf_1"};